import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { AlertComponent } from '../../alert/alert.component';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomValidation } from 'src/app/helpers/customValidation';
import { DirectorMasterService } from 'src/app/services/director-master.service';
import { Mbp4aService } from 'src/app/services/mbp4a.service';
declare var $: any;
@Component({
  selector: 'app-mbp4a',
  templateUrl: './mbp4a.component.html',
  styleUrls: ['./mbp4a.component.css']
})
export class Mbp4aComponent implements OnInit {
 
  public environmentSettings: any;

  @ViewChildren(DataTableDirective)
  dtElements: QueryList<DataTableDirective>;
  dtOptionsOfMbp: DataTables.Settings = {};
  registerDirectorList: any[];
  masterDirectorList: any[];
  FromDateModelInMasterDirector: any;
  ToDateModelInMasterDirector: any;
  dtTriggerMbp: Subject<any> = new Subject();
  error: any = { isError: false, errorMessage: '' };
  response: boolean;
  deleteMbpId: any;
  nameOfPerson: any;
  mbpForm: FormGroup;
  detailsForm: FormGroup;
  showchangecontract:any;
  dateOfShareholdersApprovalModel: { month: number; day: number; year: number; };
  dateOfTheNextMeetingModel: { month: number; day: number; year: number; };
  dateOfContractModel: { month: number; day: number; year: number; };
  dateOfArrangementModel: { month: number; day: number; year: number; };
  dateOfApprovalModel: { month: number; day: number; year: number; };
  numList: Array<string> = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  showchangeYes: boolean;
  showchargesregistered: boolean;
  addDetailsBtn:boolean;
  particularId: any;
  mbp4List: any[];
  editParticularData: any;
  dateOfContract: any;
  dateOfArrangement: any;
  dateOfApproval: any;
  restrictTabflag: boolean;
  editParticularId: any;
  director: any[];
  filterDate:any;
  nameInterestedDirector: any[];
  amountOfContractRegex = "^(?:[0-9]+(?:\.[0-9]{0,2})?)?$"
  disabledOnClick: boolean;

  constructor(private mbp4Service: Mbp4aService, private router: Router, private directorMasterService: DirectorMasterService,
    private alert: AlertComponent,private commonFunction: CommonFunction,private customValidation: CustomValidation,private activatedRoute: ActivatedRoute) {
   
  }
  ngOnInit() {
    this.mbpForm = new FormGroup({
      transactionType: new FormControl('', [Validators.required]),
      dateOfContract: new FormControl('', []),
      dateOfArrangement: new FormControl('', []),
      nameOfTheParty: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z0-9 ,.'&-]*$"),Validators.maxLength(50)]),
      anyDirectorInterested: new FormControl(false, [Validators.required]),
      relationOfPartyWithDirector: new FormControl('', [Validators.pattern("^[a-zA-Z .,&'*\n-]*$"), Validators.maxLength(50)]),
      nameOfTheInterestedDirector: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 ,.'&-]*$"), Validators.maxLength(50)]),
      relationOfPartyWithCompany: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 .,&'*\n-]*$"), Validators.maxLength(50)]),
      natureOfConcernOrInterest: new FormControl('', [Validators.required,Validators.pattern("^[a-zA-Z0-9 .,&'*\n-]*$"), Validators.maxLength(250)]),
      principalTermsAndConditions: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 .,&'*\n-]*$"), Validators.maxLength(250)]),
      whetherTheTransaction: new FormControl('', []),
      dateOfApproval: new FormControl('', [])
    });
    this.detailsForm = new FormGroup({
      noOfDirectorsPresentInTheMeeting: new FormControl('', [Validators.pattern("^[0-9]*$"), Validators.maxLength(2)]),
      directorsVotingInFavour: new FormControl('', [Validators.pattern("^[0-9]*$"), Validators.maxLength(2)]),
      directorsVotingAgainst: new FormControl('', [Validators.pattern("^[0-9]*$"), Validators.maxLength(2)]),
      directorsRemainingNeutral: new FormControl('', [Validators.pattern("^[0-9]*$"), Validators.maxLength(2)]),
      dateOfTheNextMeeting: new FormControl('', []),
      referenceOfSpecificItems: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 ,-.&]*$"), Validators.maxLength(50)]),
      amountOfContract: new FormControl('', [Validators.required, Validators.pattern(this.amountOfContractRegex), Validators.maxLength(17)]),
      // amountOfContract: new FormControl('', [Validators.required]),
      dateOfShareholdersApproval: new FormControl('', [])

    });
    this.activatedRoute.params.subscribe(params => {
      if (params['particularId'] != undefined) {
        this.restrictTabflag = true;
        this.editParticularId = params['particularId'];
        this.getMbpById(this.editParticularId);
      } else {
        this.restrictTabflag = false;
      }
    })

    this.getMasterDirector();

  }

  getMasterDirector() {
    this.nameInterestedDirector = [];
    var filterDate = {
      FromDate: null,
      ToDate: null,
    }

    this.directorMasterService.getMasterDirector(filterDate)
    .subscribe(masterDirectorList => {
      this.masterDirectorList = masterDirectorList.directorList;
    });
  }

  back(){
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['mbp4aList']  } }],
      { relativeTo: this.activatedRoute.parent });
  }
  setDate(date) {
    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }
   
  noBlankSpaceAtStart(ev) {
    if (ev.which === 32 && ev.target.selectionStart === 0) {
      return false;
    }
  } 

  saveTransactionFormEntry( ) {
    this.disabledOnClick = true;
    var object = {
            transactionType:this.mbpForm.controls.transactionType.value,
            dateOfContract: this.setDate(this.mbpForm.controls.dateOfContract.value),
            dateOfArrangement: this.setDate(this.mbpForm.controls.dateOfArrangement.value), 
            nameOfTheParty: this.mbpForm.controls.nameOfTheParty.value, 
            anyDirectorInterested: this.mbpForm.controls.anyDirectorInterested.value,
            relationOfPartyWithDirector:  this.mbpForm.controls.relationOfPartyWithDirector.value,
            nameOfTheInterestedDirector: this.mbpForm.controls.nameOfTheInterestedDirector.value,
            relationOfPartyWithCompany: this.mbpForm.controls.relationOfPartyWithCompany.value, 
            natureOfConcernOrInterest: this.mbpForm.controls.natureOfConcernOrInterest.value,
            principalTermsAndConditions: this.mbpForm.controls.principalTermsAndConditions.value,
            whetherTheTransaction: this.mbpForm.controls.whetherTheTransaction.value,
            dateOfApproval: this.setDate(this.mbpForm.controls.dateOfApproval.value),
    }
    
    this.mbp4Service.addMbpData(object).subscribe(response => {
      this.disabledOnClick = false;
      if (response.status == 0) {
        this.restrictTabflag = true;
        this.alert.successWithOk(response.message, 'mbp4a/edit/' + response.data._id);
      } else {
        this.restrictTabflag = false;
        if(response.err_fields){
          this.alert.error(response.err_fields + ' fields are required or invalid.');
        }else{
          this.alert.error(response.message);
        }
      }
    })
  }
  saveDetailsFormEntry() {
    this.disabledOnClick = true;
    var detailsOfVoting = {
      noOfDirectorsPresentInTheMeeting: this.detailsForm.controls.noOfDirectorsPresentInTheMeeting.value,
      directorsVotingInFavour: this.detailsForm.controls.directorsVotingInFavour.value,
      directorsVotingAgainst: this.detailsForm.controls.directorsVotingAgainst.value,
      directorsRemainingNeutral:this.detailsForm.controls.directorsRemainingNeutral.value,
      dateOfTheNextMeeting: this.setDate(this.detailsForm.controls.dateOfTheNextMeeting.value),
      referenceOfSpecificItems: this.detailsForm.controls.referenceOfSpecificItems.value,
      amountOfContract: this.detailsForm.controls.amountOfContract.value,
      dateOfShareholdersApproval: this.setDate(this.detailsForm.controls.dateOfShareholdersApproval.value),
      particularId: this.editParticularId
    }

    this.mbp4Service.sampleDetailsRecordEntry(detailsOfVoting).subscribe(response => {
      this.disabledOnClick = false;
      if (response.status == 0) {
        this.alert.success(response.message)
      } else {
        if(response.err_fields){
          this.alert.error(response.err_fields + ' fields are required or invalid.');
        }else{
          this.alert.error(response.message);
        }
      }
    })

  }
  setFormatDate(date) {
    if (date != null) {
      return new Date(date);
    }
    return null;
  }

  getMbpById(particularId) {
    this.mbp4Service.getMbpById(particularId).subscribe(response => {
      this.editParticularData = response.data[0];
      this.mbpForm.controls.transactionType.setValue(this.editParticularData.transactionType);
      this.mbpForm.controls.dateOfContract.setValue(this.editParticularData.dateOfContract);
      this.mbpForm.controls.dateOfArrangement.setValue(this.editParticularData.dateOfArrangement);
      this.mbpForm.controls.nameOfTheParty.setValue(this.editParticularData.nameOfTheParty);
      this.mbpForm.controls.anyDirectorInterested.setValue(this.editParticularData.anyDirectorInterested);
      this.mbpForm.controls.relationOfPartyWithDirector.setValue(this.editParticularData.relationOfPartyWithDirector);
      this.mbpForm.controls.nameOfTheInterestedDirector.setValue(this.editParticularData.nameOfTheInterestedDirector);
      this.mbpForm.controls.relationOfPartyWithCompany.setValue(this.editParticularData.relationOfPartyWithCompany);
      this.mbpForm.controls.natureOfConcernOrInterest.setValue(this.editParticularData.natureOfConcernOrInterest);
      this.mbpForm.controls.principalTermsAndConditions.setValue(this.editParticularData.principalTermsAndConditions);
      this.mbpForm.controls.whetherTheTransaction.setValue(this.editParticularData.whetherTheTransaction);
      this.mbpForm.controls.dateOfApproval.setValue(this.editParticularData.dateOfApproval);
      

      
      if (this.editParticularData.anyDirectorInterested=="true") {
        this.showchangeYes = true;
        $('#changeyes').prop("checked", true);
      } else {
       
        this.showchangeYes = false;
         $('#changeno').prop("checked", true);
      }

      

      if (this.editParticularData.dateOfContract != null) {
        let dt = new Date(this.setFormatDate(this.editParticularData.dateOfContract));
        this.dateOfContractModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.editParticularData.dateOfArrangement != null) {
        let dt = new Date(this.setFormatDate(this.editParticularData.dateOfArrangement));
        this.dateOfArrangementModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.editParticularData.dateOfApproval != null) {
        let dt = new Date(this.setFormatDate(this.editParticularData.dateOfApproval));
        this.dateOfApprovalModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }


      if (this.editParticularData.detailsOfVoting) {
        this.addDetailsBtn = false;
        this.detailsForm.controls.noOfDirectorsPresentInTheMeeting.setValue(this.editParticularData.detailsOfVoting.noOfDirectorsPresentInTheMeeting);
        this.detailsForm.controls.directorsVotingInFavour.setValue(this.editParticularData.detailsOfVoting.directorsVotingInFavour);
        this.detailsForm.controls.directorsVotingAgainst.setValue(this.editParticularData.detailsOfVoting.directorsVotingAgainst);
        this.detailsForm.controls.directorsRemainingNeutral.setValue(this.editParticularData.detailsOfVoting.directorsRemainingNeutral);
        this.detailsForm.controls.dateOfTheNextMeeting.setValue(this.editParticularData.detailsOfVoting.dateOfTheNextMeeting);
        this.detailsForm.controls.referenceOfSpecificItems.setValue(this.editParticularData.detailsOfVoting.referenceOfSpecificItems);
        this.detailsForm.controls.amountOfContract.setValue(this.editParticularData.detailsOfVoting.amountOfContract);
        this.detailsForm.controls.dateOfShareholdersApproval.setValue(this.editParticularData.detailsOfVoting.dateOfShareholdersApproval);
        if (this.editParticularData.detailsOfVoting.dateOfTheNextMeeting != null) {
          let dt = new Date(this.setFormatDate(this.editParticularData.detailsOfVoting.dateOfTheNextMeeting));
          this.dateOfTheNextMeetingModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
        }
        if (this.editParticularData.detailsOfVoting.dateOfShareholdersApproval != null) {
          let dt = new Date(this.setFormatDate(this.editParticularData.detailsOfVoting.dateOfShareholdersApproval));
          this.dateOfShareholdersApprovalModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
        }

      } else {
        this.addDetailsBtn = true;
      }
    })
  }
  

  updateMbpData() {
    this.disabledOnClick = true;
    var object = {
      transactionType: this.mbpForm.controls.transactionType.value,
      dateOfContract: this.setDate(this.dateOfContractModel),
      dateOfArrangement: this.setDate(this.dateOfArrangementModel),
      nameOfTheParty: this.mbpForm.controls.nameOfTheParty.value,
      anyDirectorInterested: this.mbpForm.controls.anyDirectorInterested.value,
      relationOfPartyWithDirector: this.mbpForm.controls.relationOfPartyWithDirector.value,
      nameOfTheInterestedDirector: this.mbpForm.controls.nameOfTheInterestedDirector.value,
      relationOfPartyWithCompany: this.mbpForm.controls.relationOfPartyWithCompany.value,
      natureOfConcernOrInterest: this.mbpForm.controls.natureOfConcernOrInterest.value,
      principalTermsAndConditions: this.mbpForm.controls.principalTermsAndConditions.value,
      whetherTheTransaction: this.mbpForm.controls.whetherTheTransaction.value,
      dateOfApproval: this.setDate(this.dateOfApprovalModel),
     
    }
    
    this.mbp4Service.updateMbpData(this.editParticularId, object).subscribe(response => {
      this.disabledOnClick = false;
      if (response.status == 0) {
        this.alert.success(response.message);
      } else {
        if(response.err_fields){
          this.alert.error(response.err_fields + ' fields are required or invalid.');
        }else{
          this.alert.error(response.message);
        }
      }

    })
  }

  changeTransactionType(value){
    if(value == 'contract')
    {
    this.mbpForm.controls.dateOfContract.setValidators([Validators.required]);
    this.mbpForm.controls.dateOfArrangement.setValidators([]);
    this.mbpForm.controls.dateOfArrangement.setValue('');
    
    }
    else{
        this.mbpForm.controls.dateOfArrangement.setValidators([Validators.required]);
        this.mbpForm.controls.dateOfContract.setValidators([]);
        this.mbpForm.controls.dateOfContract.setValue('');
    }
      this.mbpForm.controls.dateOfContract.updateValueAndValidity();
      this.mbpForm.controls.dateOfArrangement.updateValueAndValidity();
  }


  funDirector(value){
    if(value=='true')
    {
      this.showchangeYes = true;
      this.mbpForm.controls.relationOfPartyWithDirector.setValidators([Validators.required,Validators.pattern("^[a-zA-Z .,&'*\n-]*$"), Validators.maxLength(50)]);
      this.mbpForm.controls.nameOfTheInterestedDirector.setValidators([Validators.required, Validators.pattern("^[a-zA-Z0-9 ,.'&-]*$"), Validators.maxLength(50)]);
      this.mbpForm.controls.relationOfPartyWithCompany.setValidators([Validators.required, Validators.pattern("^[a-zA-Z0-9 .,&'*\n-]*$"), Validators.maxLength(50)]);

    }
    else{
      this.showchangeYes = false;
      this.mbpForm.controls.relationOfPartyWithDirector.setValidators([]);
      this.mbpForm.controls.nameOfTheInterestedDirector.setValidators([]);
      this.mbpForm.controls.relationOfPartyWithCompany.setValidators([]);
    }
      this.mbpForm.controls.relationOfPartyWithDirector.updateValueAndValidity();
      this.mbpForm.controls.nameOfTheInterestedDirector.updateValueAndValidity();
      this.mbpForm.controls.relationOfPartyWithCompany.updateValueAndValidity();
  }

  onlyNumber(ev) {
    var keyCode = window.event ? ev.keyCode : ev.which;
   
    if ((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106) || (keyCode > 34 && keyCode < 41) || (keyCode == 16) || (keyCode == 46) || (keyCode == 9)) {

      if (((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106)) && this.numList.indexOf(ev.key) == -1) {
        ev.preventDefault();
      }
    }
    else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
        ev.preventDefault();
      }
    }
  }
  onlyTwoDecimal(ev) {
    $('.dacimalFix').on('input', function () {
      this.value = this.value.replace(/(\.[\d]{2})./g, '$1'); // not more than 2 digits after decimal
    });
  }


showchangeYesClick() {
  this.showchangeYes = true;
}

hidechangeyesClick() {
  this.showchangeYes = false;
  this.mbpForm.controls.relationOfPartyWithDirector.setValue(null);
  this.mbpForm.controls.nameOfTheInterestedDirector.setValue(null);
  this.mbpForm.controls.relationOfPartyWithCompany.setValue(null);
}

chargesRegisteredYesClick() {
  this.showchargesregistered = true;
}

chargesRegisteredNoClick() {
  this.showchargesregistered = false;
}

generateOutput() {
  var object = {
    id: this.editParticularId,
    fromDate: null,
    toDate: null,
    name: null,
    param1: null,
    date1: null
  }
  this.mbp4Service.generateMbp4aDocument(object).subscribe(response => {
    if (response.status == 0) {
      this.alert.success(response.message);
      var self = this;
        setTimeout(function () {
          self.downloadDocument(self.editParticularId);
          setTimeout(function () {
            self.downloadPdfDocument(self.editParticularId);
          }, 1000);
        }, 1000);
    } else {
      this.alert.error(response.message);
    }
  })
}

downloadDocument(id) {
  this.mbp4Service.downloadMbp4aFile(id, 'Single');
}
downloadPdfDocument(id) {
  this.mbp4Service.downloadMbp4aPdfFile(id, 'Single');
}


}